var _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgBiggestWin = function SvgBiggestWin(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 23,
    fill: "none",
    viewBox: "0 0 25 23"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#FFD766",
    d: "M24.449 10.446c1.08-1.011.483-2.772-1.008-2.979l-5.487-.765a1.82 1.82 0 0 1-1.37-.955L14.131.974c-.666-1.299-2.595-1.299-3.262 0L8.416 5.747a1.81 1.81 0 0 1-1.37.955l-5.486.765C.067 7.676-.528 9.436.552 10.446l3.97 3.716c.428.4.624.979.523 1.545l-.938 5.247c-.254 1.427 1.305 2.514 2.64 1.842l4.907-2.477a1.89 1.89 0 0 1 1.693 0l4.908 2.477c1.334.673 2.894-.415 2.64-1.842l-.938-5.247c-.101-.566.094-1.144.523-1.546z"
  })));
};
export default SvgBiggestWin;